import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAVEL = {
  nickname: 'PRODUCTS.TRAVEL.nickname',
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.PLUS', value: 'PLUS' }
        ]
      }
    },
    { name: 'travelType', key: 'TRAVEL_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.PERSONAL', value: 'PERSONAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.FAMILY', value: 'FAMILY' }
        ]
      }
    },
    { name: 'travelDuration', key: 'TRAVEL_DURATION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION_SCOOPR.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION_SCOOPR.75', value: '75' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION_SCOOPR.90', value: '90' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION_SCOOPR.120', value: '120' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION_SCOOPR.150', value: '150' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION_SCOOPR.180', value: '180' }
        ]
      }
    },
    { name: 'travelDurationType', key: 'TRAVEL_DURATION_TYPE', group: 'OBJECT_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
  ],
  icon:'travel'
};
